<template>
    <div class="MenuSide-MAIN">

        <img src="../assets/ApArt-Logo-Black.png" @click="setView('parenthesis')"/>
        <hr/>
        <div>
            <div v-if="!onSession"><img src="../assets/icon-person.png" @click="setView('login')"/></div>
            <div v-if="onSession"><img src="../assets/icon-person.png" @click="setView('profile')"/></div>
            <div v-if="onSession"><img src="../assets/icon-inbox.png"/></div>
            <!--<div v-if="onSession"><img src="../assets/icon-bookmark.png"/></div>-->
            <div @click="setView('pwa')"><img src="../assets/icon-download.png"/></div>
            <div @click="setView('subscribe')"><img src="../assets/icon-newspaper.png" style="scale:1.2;"/></div>
            <!--<div class="ap"><img src="../assets/icon-ap.png"/></div>-->
            <div @click="setView('about')"><img src="../assets/icon-question-mark-circle.png"/></div>
            <div @click="setView('cookies')"><img src="../assets/icon-settings.png"/></div>
        </div>

    </div>
</template>

<script>
export default{
    name: 'MenuSide',
    props: {
        active: Boolean
    },
    data(){
        return{
            onSession: false,
        }
    },
    watch: {
        active(newValue) {
            if(newValue) {
                this.checkSession();
            }
        }
    },
    methods: {
        checkSession() {
            const token = localStorage.getItem('token');
            const userData = JSON.parse(localStorage.getItem('userData') || '{}');
            this.onSession = !!token && !!userData.id;
        },

        setView(view){
            this.$parent.toggleSideMenu(false);
            this.$router.push({ name: view });
        }
    },
    mounted() {
        this.checkSession();
    },
}
</script>

<style scoped lang="stylus">
.MenuSide-MAIN
    height: 100vh
    background-color: #DCDCDC
    width: 20vw
    min-width: 20vw
    border-radius: 10vw 0 0 10vw
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    z-index: 1

    >img
        width:75%;
        cursor: pointer

    >div
        display: flex
        flex-direction: column
        align-items: center
        justify-content: center

        div
            display: flex
            align-items: center
            justify-content: center
            width: 8vw
            aspect-ratio: 1/1
            margin: 1vh 0

            img
                max-width: 100%
                max-height: 100%
                cursor: pointer

        .ap img
            scale: 0.65

hr
    width:75%
    margin-top: 3vw
    border-top: 1px solid #707070
</style>